
import { configureStore } from '@reduxjs/toolkit';

import BPMReducer from '../reducers/BPMReducer';

const BPMStore = configureStore({
    reducer: BPMReducer,
});

export default BPMStore;